import React, { useEffect, useState } from 'react';
import { Box, Card, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import './Teams.css';
import AddEditForm from './components/AddEditForm/AddEditForm';
import TeamList from './components/TeamList/TeamList';
import { connect } from 'react-redux';
import CustomTheme from '../../../../utilities/theme/theme.json'
import NoTeamFound from './components/NoTeamFound/NoTeamFound';
import { getAllTeamsRequset } from '../../../configuration/ConfigurationApiActions';

const Teams = ({ history, match, getAllTeams, allTeams }) => {

    const [showNewTeamForm, setShowNewTeamForm] = useState(false);
    const [rowIndex, setRowIndex] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [addNewTeam, setAddNewTeam] = useState(false)

    useEffect(() => {
        getAllTeams().then((res) => {
            if (res.length !== 0) {
                setShowNewTeamForm(true)
            } else { }
        })
    }, [])

    return (
        <>
            {
                allTeams.length !== 0 || showNewTeamForm
                    ?
                    <Box>
                        <Grid container>
                            <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
                                <Card className="new-team-list">
                                    <Grid style={{ borderBottom: `1px dashed ${CustomTheme.primaryColor}` }} container
                                        justify="space-between" spacing={0} className='table-title-style'>
                                        <Grid>

                                        </Grid>
                                        <Grid>
                                            <Box className="header-buttons-in-list">
                                                <Button size="small"
                                                    onClick={() => {
                                                        setSelectedRow(null);
                                                        setAddNewTeam(true)
                                                        setRowIndex(null);
                                                    }}
                                                    variant="outlined"
                                                    color="primary"
                                                    className="blank-page-button-milestone margin-top-team-btn"><i
                                                        className="fas fa-users"></i> <span className="btn-margin-left"> + TEAM</span>
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <TeamList
                                        history={history}
                                        match={match}
                                        selectedRow={selectedRow}
                                        setSelectedRow={setSelectedRow}
                                        rowIndex={rowIndex}
                                        setRowIndex={setRowIndex}
                                    />
                                </Card>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                                {
                                    selectedRow != null || addNewTeam
                                        ?
                                        <Card className="new-team-detail-panel">
                                            <AddEditForm
                                                rowIndex={rowIndex}
                                                setRowIndex={setRowIndex}
                                                setAddNewTeam={setAddNewTeam}
                                                addNewTeam={addNewTeam}
                                                setSelectedRow={setSelectedRow}
                                            />
                                        </Card>
                                        :
                                        <></>
                                }
                            </Grid>
                        </Grid>
                    </Box>
                    :
                    <NoTeamFound setShowNewTeamForm={setShowNewTeamForm} setAddNewTeam={setAddNewTeam} />
            }
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        allTeams: state.configuration.teams
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllTeams: () => {
            return dispatch(getAllTeamsRequset()).then((res) => {
                return Promise.resolve(res);
            }, (error) => {
                return Promise.reject(error);
            });
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Teams);
